import { checkboxAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  checkboxAnatomy.keys
);

const CheckboxStyles = defineMultiStyleConfig({
  defaultProps: { colorScheme: 'bGreen' },
});

export default CheckboxStyles;
